import React, { useState } from "react";

const PDFUploader = () => {
  const [fileName, setFileName] = useState(null);
  const [status, setStatus] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setFileName(file.name);
      setStatus("");
    } else {
      setFileName(null);
      setStatus("Por favor selecciona un archivo PDF válido.");
    }
  };

  const handleSubmit = () => {
    if (!fileName) {
      setStatus("Por favor selecciona un archivo primero.");
      return;
    }
    setStatus("Cargando documento...");
    setTimeout(() => {
      setStatus("¡Documento enviado con éxito!");
    }, 2000);
  };

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "10% auto 0 auto", // margin-top: 3rem para más separación arriba
        padding: "2.5rem 3rem",
        border: "1px solid #d1d5db", // gris claro elegante
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#1f2937",
      }}
    >
      <h2
        style={{
          marginBottom: "1.5rem",
          textAlign: "center",
          fontWeight: "700",
          fontSize: "1.8rem",
          color: "#2563eb",
          letterSpacing: "0.03em",
        }}
      >
        Suba su documento PDF
      </h2>

      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileChange}
        style={{
          display: "block",
          marginBottom: "1.5rem",
          width: "100%",
          padding: "0.6rem",
          fontSize: "1rem",
          borderRadius: "6px",
          border: "1px solid #cbd5e1",
          transition: "border-color 0.3s ease",
          cursor: "pointer",
        }}
        onFocus={(e) => (e.target.style.borderColor = "#2563eb")}
        onBlur={(e) => (e.target.style.borderColor = "#cbd5e1")}
      />

      {fileName && (
        <p
          style={{
            marginBottom: "1.5rem",
            fontWeight: "600",
            color: "#374151",
            textAlign: "center",
          }}
        >
          Archivo seleccionado: <span style={{ color: "#2563eb" }}>{fileName}</span>
        </p>
      )}

      <button
        onClick={handleSubmit}
        style={{
          padding: "12px 0",
          backgroundColor: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          width: "100%",
          fontSize: "1.1rem",
          fontWeight: "600",
          boxShadow: "0 4px 8px rgba(37, 99, 235, 0.4)",
          transition: "background-color 0.3s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#1d4ed8")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#2563eb")}
      >
        Subir Documento
      </button>

      {status && (
        <p
          style={{
            marginTop: "2rem",
            color: status.includes("error") || status.includes("válido")
              ? "#dc2626"
              : "#16a34a",
            fontWeight: "600",
            textAlign: "center",
            fontSize: "1rem",
          }}
        >
          {status}
        </p>
      )}
    </div>
  );
};

export default PDFUploader;
